module.exports = __webpack_public_path__ + "files/9093b6b8da682904805200eb1958f70b.png";